import React, { useState } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button, Modal, Spacer, Spinner, Typography } from '@telus-uds/components-web';
import FileDownload from 'js-file-download';
import axios from 'axios';

import { ButtonWrapper } from './css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { apiHost, config } from '../../../../utils/request';

const ExportReport = ({ getPayload }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      EXPORT,
      confirmationDialog,
      confirmationMessage,
      exportWarning,
      confirm,
      cancel
    }
  } = localizedStrings;

  const [isExporting, setIsExporting] = useState(false);
  const [showWarningMessage, setShowWarningMessage] = useState(false);

  const exportFile = async () => {
    try {
      setIsExporting(true);
      const result = await axios.post(
        `${apiHost}/orders/export/excel`,
        getPayload(),
        {
          ...config(),
          responseType: 'arraybuffer'
        }
      );
      if (result) {
        FileDownload(_.get(result, 'data', ''), 'orders.xlsx');
        setIsExporting(false);
      }
    } catch (error) {
      setIsExporting(false);
    }
  };

  const onClickExport = () => {
    const payload = getPayload();
    if (!payload.filterCriteria) {
      setShowWarningMessage(true);
    } else {
      exportFile();
    }
  };

  return (
    <>
      <ButtonWrapper>
        <Spinner
          label="Exporting Report..."
          variant={{ size: 'small' }}
          show={isExporting}
          inline
        >
          <Button onPress={onClickExport}>{EXPORT}</Button>
        </Spinner>
      </ButtonWrapper>
      <Modal
        isOpen={showWarningMessage}
        onClose={() => {
          setShowWarningMessage(false);
        }}
      >
        <Typography variant={{ size: 'h2' }}>{confirmationDialog}</Typography>
        <Spacer space={1} />
        <p>{`${exportWarning} ${confirmationMessage}?`}</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button
            type="button"
            variant={{ priority: 'low' }}
            onPress={() => {
              setShowWarningMessage(false);
            }}
          >
            {cancel}
          </Button>
          <Button
            type="button"
            variant={{ priority: 'high' }}
            onPress={() => {
              setShowWarningMessage(false);
              exportFile();
            }}
          >
            {confirm}
          </Button>
        </div>
      </Modal>
    </>
  );
};

ExportReport.propTypes = {
  getPayload: PropTypes.func.isRequired
};

export default ExportReport;
